export default __webpack_public_path__ + "static/cafe_36029-bbc04622906dc7cb8e30dc1d6eceac1e.png";